export const HFG_BULLSEYE_ADD_ON = 'bullseye'

export const HFG_MULTIPLIER_ADD_ONS = ['kenoBonus', 'kenoBooster', 'kenoMultiplier'] as const

export const HFG_POSSIBLE_BONUS_ADD_ONS = [...HFG_MULTIPLIER_ADD_ONS, HFG_BULLSEYE_ADD_ON] as const

export const HFG_ADD_ONS = [...HFG_POSSIBLE_BONUS_ADD_ONS, 'specialKeno'] as const

type HfgAddOn = (typeof HFG_ADD_ONS)[number]

export const HFG_DRAW_RESULT_MAIN_FIELD = 'main'

const HFG_ADD_ON_ILLUSTRATIONS = {
  bullseye: 'bullseye-active',
  kenoBonus: 'bonus-active',
  kenoBooster: 'booster-active',
  kenoMultiplier: 'multiplier-active',
  specialKeno: 'special-keno-active',
} as const satisfies Record<HfgAddOn, string>

const isHfgAddOn = (name: string): name is HfgAddOn => name in HFG_ADD_ON_ILLUSTRATIONS

export const getHfgAddOnIllustration = (name: string) =>
  isHfgAddOn(name) ? HFG_ADD_ON_ILLUSTRATIONS[name] : null
